import { render, staticRenderFns } from "./xdslDivider.vue?vue&type=template&id=436f5a1d&scoped=true&"
var script = {}
import style0 from "./xdslDivider.vue?vue&type=style&index=0&id=436f5a1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436f5a1d",
  null
  
)

export default component.exports